export default "__VITE_ASSET__F$vnvYb5__"